module.exports = __webpack_public_path__ + "img/MirandaLosgrove.9754412e.jpg";